import { render } from "./OrdersWeb.vue?vue&type=template&id=fe712d2a&scoped=true"
import script from "./OrdersWeb.vue?vue&type=script&lang=js"
export * from "./OrdersWeb.vue?vue&type=script&lang=js"

import "./OrdersWeb.vue?vue&type=style&index=0&id=fe712d2a&lang=scss&scoped=true"
import "./OrdersWeb.vue?vue&type=style&index=1&id=fe712d2a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fe712d2a"

export default script